module.exports = __webpack_public_path__ + "media/images/users/free-4e8b0617045772d27726be217779c057.png";